// Address of the signalling relay Worker. Empty string keeps the Firestore path.
export const SIGNAL_URL = "wss://passcall-signal.kaiserkarma.workers.dev";
